/* Note: this is the V3 endpoint for now! */

import { z } from "zod";

import { fetchWithError, useParsedQuery } from "@nens/react-query-utils";
import { combineUrlAndParams } from "@nens/shared-utils";

import { paginatedSchema } from "../pagination";

export const searchResultSchema = z.object({
  id: z.number(),
  title: z.string(),
  description: z.string(),
  rank: z.number(),
  entity_name: z.string() /* Asset type */,
  entity_id: z.number(),
  entity_uuid: z.string().nullable(),
  entity_url: z.string(),
  view: z.tuple([z.number(), z.number(), z.number()]) /* Lat, lon, zoom */,
});

export type SearchResult = z.infer<typeof searchResultSchema>;

export const paginatedSearchResultSchema = paginatedSchema(searchResultSchema);
export type SearchResultList = z.infer<typeof paginatedSearchResultSchema>;

export function useSearch(q: string, type?: string, params = {}) {
  const actualParams: Record<string, string> = { ...params, q };
  if (type) actualParams["type"] = type;

  const url = combineUrlAndParams("/api/v4/search/", actualParams);
  return useParsedQuery<SearchResultList>(
    ["lizard-api-v4", "search", url],
    () => fetchWithError(url),
    (json: unknown) => paginatedSearchResultSchema.parse(json),
    { enabled: q !== "" }
  );
}
